<template>
  <Fragment>
    <template v-if="$route.name !== 'createCodeIndex'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <div class="left">
            <el-button type="primary" class="mr-20" @click="addCreateCode"
              >添加码记录</el-button
            >
          </div>
        </section>
      </div>
      <el-table :data="list" style="width: 150%" border>
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="生成码数量" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.createCount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="起始值" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.startCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="终止值" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.endCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="区域名称" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.typeName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="服务地址" width="410">
          <template slot-scope="scope">
            <span>{{ scope.row.serviceUrl }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.status === 1 ? "已生成" : "未生成" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="editCreateCodeInfo(scope.row)"
              >编辑</el-button
            >
            <el-button size="mini" @click="downloadCreateCode(scope.row)"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20 pagination"
        background
        layout="total,prev, pager, next, jumper"
        :total="total"
        :page-size="10"
        :current-page="pageNum"
        @prev-click="handlePrePage"
        @next-click="handleNextPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import Setting from "@/config/setting";
import Breadcrumb from "@/components/Breadcrumb";
export default {
  name: "role",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      pmCount: "",
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    getCreateCodeList() {
      let _this = this;
      let param = {
        url: "/api/createCode/geCreateCodeRecordPage",
        params: {
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getCreateCodeList", param).then(() => {
        _this.list = _this.$store.state.createCode.createCodeList.list;
        _this.total = _this.$store.state.createCode.createCodeList.total;
      });
    },
    //查询
    searchCreateCodeInfo() {
      let _this = this;
      _this.getCreateCodeList();
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getCreateCodeList();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getCreateCodeList();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getCreateCodeList();
    },
    //编辑
    editCreateCodeInfo(row) {
      this.$router.push({
        name: "editCreateCodeInfo",
        params: { createCodeRecordId: row.createCodeRecordId }
      });
    },
    //添加
    addCreateCode() {
      this.$router.push({
        name: "addCreateCodeInfo"
      });
    },
    //下载
    downloadCreateCode: function(row) {
      window.open(Setting.baseUrl + row.filePath, "_blank");
    }
  },
  created() {
    let _this = this;
    _this.getCreateCodeList();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
    display: flex
    align-items: center
    justify-content: space-between
    .left
      display: flex
    .el-button
      font-size: 14px
    .search-name, .search-code
      font-size: 14px
      display: flex
      align-items: center
      span
        white-space: nowrap
.pagination
  text-align: center
</style>
